(function () {
    'use strict';

    angular.module('inoApp.directives.layout').directive('layoutRibbon', [function () {
        var directive = {
            restrict: 'AE',
            replace: false,
            templateUrl: 'templates/core/layout/ribbon.html'
        };

        return directive;
    }]);
})();